<template>
  <footer
    class="container flex items-center px-8 py-12 justify-between md:mb-16"
  >
    <a href="https://wa.me/5492616502203" target="_blank" class="fixed bottom-11 lg:right-11 right-6 z-10 p-2">
      <img
        src="../assets/img/wsp.svg"
        alt="WhatsApp"
        class="w-12"
      />
    </a>
    <div class="md:w-3/4 flex flex-col md:flex-row items-start">
      <div class="flex leading-tight md:items-center md:mb-0">
        <div class="flex mr-4">
          <!-- <a class="btn btn-outline-primary p-2 mr-2" href="/">
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
            />
          </svg>
          </a> -->
          <a class="btn btn-outline-primary p-2" href="tel:+5492616502203">
            <svg
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              />
            </svg>
          </a>
        </div>

        <div>
          <p>261 650 2203</p>
          <a href="mailto:consultas@clic.social" class="hover:underline"
            >consultas@clic.social</a
          >
        </div>
      </div>
      <!-- <div class="md:w-80">
        <h4 class="font-bold text-lg font-questrial mb-2 text-primary-900">
          Nosotros
        </h4>
        <p class="text-sm">
          Somos un grupo de abogados y profesionales autónomos e independientes
          que buscan generar un cambio mediante la creación de herramientas
          virtuales al servicio de nuestra comunidad.
        </p>
      </div> -->
    </div>

    <div>
      <a href="https://instagram.com/guaw.ar" target="_blank" class="invisible md:visible">
        <svg
          class="fill-current text-gray-300 hover:text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          width="73"
          height="50"
        >
          <path
            d="M73 2.583c0-.419-.403-.78-.905-.78-.512 0-.905.448-.905.776v9.28c-1.206-1.621-2.66-3.565-2.984-4.027a.787.787 0 00-.254-.339l-.017-.012a.908.908 0 00-.116-.075l-.004-.002a.995.995 0 00-.466-.117c-.512 0-.905.448-.905.776v9.603c-1.341-4.86-2.936-10.604-2.936-10.717v-.04c0-.419-.403-.78-.905-.78-.512 0-.905.448-.905.776v25.82c-1.34-11.358-2.936-24.834-2.936-24.947 0-.418-.403-.78-.905-.78-.512 0-.905.448-.905.776l.001.01v12.352C55.61 14.77 54.015 8.42 54.015 8.308c0-.42-.403-.78-.905-.78-.512 0-.905.447-.905.776l.001.007v22.831C50.864 21.393 49.27 9.832 49.27 9.72c0-.419-.403-.78-.905-.78-.512 0-.905.448-.905.776v13.322c-1.323-5.689-2.913-12.541-2.947-12.65-.088-.288-.368-.481-.696-.513a1.025 1.025 0 00-.198-.02c-.512 0-.905.447-.905.775v12.54c-1.34-6.267-2.936-13.685-2.936-13.798 0-.419-.403-.78-.905-.78-.512 0-.905.448-.905.776l.001.01V32.803c-1.342-12.068-2.937-26.39-2.937-26.502 0-.419-.403-.78-.905-.78-.512 0-.905.448-.905.776v13.347c-1.34-7.685-2.936-16.792-2.936-16.904v-.023c0-.419-.403-.78-.905-.78-.512 0-.905.448-.905.776V27.44C27.136 15.3 25.54.892 25.54.78c0-.418-.403-.779-.905-.779-.512 0-.905.447-.905.776v17.773c-1.34-6.29-2.936-13.735-2.936-13.847 0-.419-.403-.78-.905-.78-.512 0-.905.448-.905.776v12.416c-1.332-3.973-2.94-8.766-2.974-8.875-.1-.322-.44-.525-.818-.513-.017 0-.032-.004-.05-.004-.511 0-.904.447-.904.775v7.445c-1.314-3.024-2.904-6.677-2.945-6.783a.707.707 0 00-.378-.379.993.993 0 00-.518-.144c-.512 0-.905.448-.905.776v4.284c-1.31-1.607-2.983-3.66-3.083-3.785a.946.946 0 00-.758-.36c-.512 0-.905.447-.905.775v3.531c-1.382-1.766-3.11-3.973-3.178-4.068-.245-.337-.781-.387-1.186-.088-.413.306-.468.902-.276 1.167.092.127 4.851 6.273 4.985 6.365l.013.01c.017.01.033.023.05.033a.78.78 0 00.453.128c.015 0 .029.004.044.004.512 0 .905-.448.905-.776V12.97c1.317 1.618 2.999 3.68 3.072 3.773.033.042.07.079.112.11.165.152.397.25.657.25.512 0 .905-.448.905-.776v-2.594c1.321 3.04 2.94 6.765 2.983 6.872.118.302.45.478.809.456.017.001.032.004.049.004.512 0 .905-.447.905-.775v-6.235c1.33 3.97 2.933 8.75 2.967 8.858a.707.707 0 00.352.407c.016.01.032.017.048.026l.022.01a.99.99 0 00.452.11c.512 0 .905-.447.905-.775v-9.41c1.34 6.297 2.936 13.772 2.936 13.885 0 .419.403.78.905.78.512 0 .905-.448.905-.776v-9.914c1.34 12.148 2.936 26.585 2.936 26.697 0 .42.403.78.905.78.512 0 .905-.448.905-.776V13.204c1.34 7.694 2.936 16.831 2.936 16.943 0 .419.403.78.905.78.512 0 .905-.448.905-.776v-7.47c1.34 12.075 2.936 26.427 2.936 26.54 0 .418.403.779.905.779.512 0 .905-.448.905-.776V17.921c1.34 6.275 2.936 13.724 2.936 13.836 0 .419.403.78.905.78.512 0 .905-.448.905-.776v-13.38c1.327 5.703 2.933 12.612 2.966 12.721.1.325.442.53.824.516.017 0 .033.004.05.004.513 0 .906-.447.906-.775v-7.879c1.34 9.756 2.936 21.348 2.936 21.46 0 .419.403.78.905.78.512 0 .905-.448.905-.776v-28.79c1.34 5.376 2.936 11.755 2.936 11.868 0 .418.403.779.905.779.512 0 .905-.447.905-.775v-4.315c1.34 11.365 2.936 24.872 2.936 24.984 0 .419.403.78.905.78.512 0 .905-.448.905-.776V13.599c1.34 4.867 2.936 10.642 2.936 10.754 0 .419.403.78.905.78.512 0 .905-.448.905-.776V10.896c1.334 1.798 2.95 3.966 2.997 4.07.132.284.456.442.802.412.014 0 .027.004.042.004.512 0 .905-.448.905-.776V2.583z"
          />
        </svg>
      </a>
    </div>
  </footer>
</template>
